import script from "./ForumPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumPopup.vue?vue&type=script&setup=true&lang=js"

import "./ForumPopup.vue?vue&type=style&index=0&id=a83a972a&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a83a972a"]])

export default __exports__